import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './questionList/svg/workflow.svg'
import _imports_1 from './svg/workflow-preview.svg'
import _imports_2 from './svg/arrow-down.svg'
import _imports_3 from './svg/arrow-right.svg'
import _imports_4 from '@/assets/images/skip-icon.svg'
import _imports_5 from '@/assets/images/download.svg'
import _imports_6 from '@/assets/images/close-icon.svg'
import _imports_7 from '@/assets/images/upload.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-028deaf9")

_pushScopeId("data-v-028deaf9")
const _hoisted_1 = {
  class: "ticket-detail",
  id: "ticket-detail"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" / ")
const _hoisted_3 = /*#__PURE__*/_createVNode("h2", null, "工单详情", -1)
const _hoisted_4 = { class: "body" }
const _hoisted_5 = {
  key: 0,
  class: "workflow-display"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "workflow" }, [
  /*#__PURE__*/_createVNode("img", { src: _imports_0 }),
  /*#__PURE__*/_createVNode("span", null, "工作流")
], -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode("预览图")
const _hoisted_9 = {
  key: 1,
  class: "task-appoint"
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode("工作流任务设定")
const _hoisted_11 = { style: {"display":"inline-block","justify-content":"center","align-items":"center","width":"16px","height":"6px"} }
const _hoisted_12 = {
  key: 0,
  src: _imports_2,
  style: {"position":"relative","top":"-2px"},
  alt: ""
}
const _hoisted_13 = {
  key: 1,
  src: _imports_3,
  alt: ""
}
const _hoisted_14 = /*#__PURE__*/_createVNode("p", null, "已变更", -1)
const _hoisted_15 = { class: "template-list" }
const _hoisted_16 = { class: "template-title" }
const _hoisted_17 = /*#__PURE__*/_createVNode("p", null, "使用中", -1)
const _hoisted_18 = {
  key: 0,
  class: "change-btn"
}
const _hoisted_19 = /*#__PURE__*/_createVNode("i", {
  class: "el-icon-sort",
  style: {"transform":"rotate(90deg)"}
}, null, -1)
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" 变更工单模版")
const _hoisted_21 = {
  key: 2,
  class: "milestone-list"
}
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "title" }, "项目计划时间", -1)
const _hoisted_23 = { class: "row" }
const _hoisted_24 = /*#__PURE__*/_createVNode("span", { class: "row-title" }, "项目开始时间", -1)
const _hoisted_25 = { class: "row" }
const _hoisted_26 = /*#__PURE__*/_createVNode("span", { class: "row-title" }, "项目结束时间", -1)
const _hoisted_27 = {
  key: 3,
  class: "milestone-list"
}
const _hoisted_28 = { class: "row" }
const _hoisted_29 = /*#__PURE__*/_createVNode("span", { class: "row-title" }, "项目经理", -1)
const _hoisted_30 = { class: "row" }
const _hoisted_31 = /*#__PURE__*/_createVNode("span", { class: "row-title" }, "交付经理", -1)
const _hoisted_32 = {
  key: 4,
  class: "milestone-list"
}
const _hoisted_33 = /*#__PURE__*/_createVNode("div", null, "里程碑关键节点", -1)
const _hoisted_34 = { class: "row-title" }
const _hoisted_35 = { class: "tag-area" }
const _hoisted_36 = /*#__PURE__*/_createVNode("i", { class: "el-icon-plus" }, null, -1)
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" 添加标签")
const _hoisted_38 = /*#__PURE__*/_createVNode("i", { class: "el-icon-plus" }, null, -1)
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" 添加标签")
const _hoisted_40 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_41 = {
  key: 0,
  class: "jinji"
}
const _hoisted_42 = {
  key: 0,
  class: "time_modify_btn"
}
const _hoisted_43 = /*#__PURE__*/_createTextVNode("修改时间")
const _hoisted_44 = /*#__PURE__*/_createVNode("i", { class: "el-icon-arrow-right" }, null, -1)
const _hoisted_45 = /*#__PURE__*/_createTextVNode("转至问题详情")
const _hoisted_46 = /*#__PURE__*/_createVNode("i", { class: "el-icon-arrow-right" }, null, -1)
const _hoisted_47 = { class: "transaction transaction-line" }
const _hoisted_48 = /*#__PURE__*/_createVNode("span", { class: "text-r" }, "客户描述:", -1)
const _hoisted_49 = { class: "comment" }
const _hoisted_50 = {
  key: 0,
  class: "transaction transaction-line"
}
const _hoisted_51 = /*#__PURE__*/_createVNode("span", { class: "text-r" }, "工单描述:", -1)
const _hoisted_52 = { class: "comment" }
const _hoisted_53 = {
  key: 0,
  class: "attachments "
}
const _hoisted_54 = {
  key: 0,
  class: "am"
}
const _hoisted_55 = { class: "file-name" }
const _hoisted_56 = /*#__PURE__*/_createVNode("img", { src: _imports_4 }, null, -1)
const _hoisted_57 = /*#__PURE__*/_createVNode("img", { src: _imports_5 }, null, -1)
const _hoisted_58 = /*#__PURE__*/_createVNode("span", null, "收起", -1)
const _hoisted_59 = /*#__PURE__*/_createVNode("i", { class: "el-icon-arrow-up" }, null, -1)
const _hoisted_60 = /*#__PURE__*/_createVNode("span", null, "展开", -1)
const _hoisted_61 = /*#__PURE__*/_createVNode("i", { class: "el-icon-arrow-down" }, null, -1)
const _hoisted_62 = {
  key: 1,
  class: "attach-img-box"
}
const _hoisted_63 = {
  key: 2,
  class: "extra-tags"
}
const _hoisted_64 = { key: 0 }
const _hoisted_65 = {
  class: "transaction transaction-line",
  style: {"border-bottom":"1px solid #f3f5f6","padding-bottom":"24px"}
}
const _hoisted_66 = /*#__PURE__*/_createVNode("span", { class: "text-r" }, "紧急程度:", -1)
const _hoisted_67 = { class: "comment" }
const _hoisted_68 = { class: "max-img" }
const _hoisted_69 = { class: "transaction transaction-line" }
const _hoisted_70 = /*#__PURE__*/_createVNode("span", {
  class: "action closed",
  style: {"margin-right":"-8px"}
}, "创建问题", -1)
const _hoisted_71 = { class: "text-r" }
const _hoisted_72 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_73 = { class: "color-35 mt8" }
const _hoisted_74 = /*#__PURE__*/_createVNode("span", { class: "comment" }, null, -1)
const _hoisted_75 = { class: "transaction transaction-line" }
const _hoisted_76 = /*#__PURE__*/_createVNode("span", {
  class: "action",
  style: {"margin-right":"-8px"}
}, "创建工单", -1)
const _hoisted_77 = { class: "text-r" }
const _hoisted_78 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_79 = { class: "color-35 mt8" }
const _hoisted_80 = /*#__PURE__*/_createVNode("span", { class: "comment" }, null, -1)
const _hoisted_81 = { class: "cost-time" }
const _hoisted_82 = {
  key: 0,
  style: {"height":"10px"}
}
const _hoisted_83 = { class: "transaction transaction-line" }
const _hoisted_84 = {
  key: 0,
  class: "action closed"
}
const _hoisted_85 = {
  key: 1,
  class: "action change-t"
}
const _hoisted_86 = {
  key: 2,
  class: "action delayed-status"
}
const _hoisted_87 = {
  key: 3,
  class: "action restart-status"
}
const _hoisted_88 = {
  key: 4,
  class: "action empty"
}
const _hoisted_89 = {
  key: 5,
  class: "operator"
}
const _hoisted_90 = { class: "text-r" }
const _hoisted_91 = {
  key: 0,
  style: {"margin":"0 4px"}
}
const _hoisted_92 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_93 = { class: "finish-time" }
const _hoisted_94 = { class: "color-35 mt8" }
const _hoisted_95 = /*#__PURE__*/_createVNode("div", { style: {"height":"20px"} }, null, -1)
const _hoisted_96 = { style: {"display":"inline-block","min-width":"140px","text-align":"right"} }
const _hoisted_97 = { key: 0 }
const _hoisted_98 = { key: 1 }
const _hoisted_99 = {
  key: 0,
  style: {"margin":"0 4px"}
}
const _hoisted_100 = {
  key: 7,
  class: "comment"
}
const _hoisted_101 = {
  key: 0,
  class: "attachments "
}
const _hoisted_102 = {
  key: 0,
  class: "am"
}
const _hoisted_103 = { class: "file-name" }
const _hoisted_104 = /*#__PURE__*/_createVNode("img", {
  src: _imports_4,
  style: {"height":"16px","width":"16px"}
}, null, -1)
const _hoisted_105 = /*#__PURE__*/_createVNode("img", { src: _imports_5 }, null, -1)
const _hoisted_106 = /*#__PURE__*/_createVNode("span", null, "收起", -1)
const _hoisted_107 = /*#__PURE__*/_createVNode("i", { class: "el-icon-arrow-up" }, null, -1)
const _hoisted_108 = /*#__PURE__*/_createVNode("span", null, "展开", -1)
const _hoisted_109 = /*#__PURE__*/_createVNode("i", { class: "el-icon-arrow-down" }, null, -1)
const _hoisted_110 = {
  key: 1,
  class: "attach-img-box"
}
const _hoisted_111 = {
  key: 2,
  class: "extra-tags"
}
const _hoisted_112 = { key: 0 }
const _hoisted_113 = /*#__PURE__*/_createVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_114 = /*#__PURE__*/_createTextVNode("点击查看完成详情")
const _hoisted_115 = {
  key: 8,
  class: "cost-time"
}
const _hoisted_116 = { class: "transaction transaction-line" }
const _hoisted_117 = /*#__PURE__*/_createVNode("span", {
  class: "action",
  style: {"min-width":"40px"}
}, "继续", -1)
const _hoisted_118 = { class: "text-r" }
const _hoisted_119 = { key: 0 }
const _hoisted_120 = { key: 0 }
const _hoisted_121 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_122 = { key: 1 }
const _hoisted_123 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_124 = { key: 2 }
const _hoisted_125 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_126 = {
  key: 1,
  class: "text-r"
}
const _hoisted_127 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_128 = { class: "tab-outside-box" }
const _hoisted_129 = { class: "tabs-box" }
const _hoisted_130 = /*#__PURE__*/_createVNode("img", { src: _imports_6 }, null, -1)
const _hoisted_131 = {
  key: 0,
  style: {"margin":"8px 0 0 0"}
}
const _hoisted_132 = /*#__PURE__*/_createTextVNode("历史节点")
const _hoisted_133 = /*#__PURE__*/_createVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_134 = /*#__PURE__*/_createVNode("span", { class: "label" }, "预览图", -1)
const _hoisted_135 = /*#__PURE__*/_createVNode("img", { src: _imports_7 }, null, -1)
const _hoisted_136 = /*#__PURE__*/_createVNode("span", null, "上传附件", -1)
const _hoisted_137 = /*#__PURE__*/_createVNode("img", { src: _imports_7 }, null, -1)
const _hoisted_138 = /*#__PURE__*/_createVNode("span", null, "上传飞书链接", -1)
const _hoisted_139 = {
  key: 0,
  class: "node-remark"
}
const _hoisted_140 = /*#__PURE__*/_createVNode("div", { class: "node-remark-title" }, "节点说明：", -1)
const _hoisted_141 = { class: "feedback-box" }
const _hoisted_142 = { key: 0 }
const _hoisted_143 = /*#__PURE__*/_createVNode("div", { class: "title" }, "输入：", -1)
const _hoisted_144 = { class: "feedback-box-body" }
const _hoisted_145 = { key: 1 }
const _hoisted_146 = /*#__PURE__*/_createVNode("div", { class: "title" }, "输出：", -1)
const _hoisted_147 = { class: "feedback-box-body" }
const _hoisted_148 = /*#__PURE__*/_createVNode("div", {
  class: "title",
  style: {"padding":"0"}
}, "回复：", -1)
const _hoisted_149 = { lass: "feedback-box-body" }
const _hoisted_150 = {
  class: "attach-img-box",
  style: {"width":"100%"}
}
const _hoisted_151 = { style: {"width":"100%"} }
const _hoisted_152 = {
  key: 0,
  class: "feishuFile"
}
const _hoisted_153 = {
  key: 1,
  class: "feishuFile"
}
const _hoisted_154 = { key: 2 }
const _hoisted_155 = /*#__PURE__*/_createTextVNode("返回")
const _hoisted_156 = /*#__PURE__*/_createTextVNode("跳过")
const _hoisted_157 = /*#__PURE__*/_createTextVNode("挂起")
const _hoisted_158 = /*#__PURE__*/_createTextVNode("继续")
const _hoisted_159 = /*#__PURE__*/_createTextVNode("已解决")
const _hoisted_160 = /*#__PURE__*/_createTextVNode("转入CS服务")
const _hoisted_161 = { key: 3 }
const _hoisted_162 = {
  key: 1,
  class: "btn-box2"
}
const _hoisted_163 = {
  key: 0,
  class: "liu-cheng-info"
}
const _hoisted_164 = /*#__PURE__*/_createTextVNode("当前节点： ")
const _hoisted_165 = { class: "nodeItem" }
const _hoisted_166 = /*#__PURE__*/_createVNode("span", null, "|", -1)
const _hoisted_167 = /*#__PURE__*/_createVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_168 = /*#__PURE__*/_createTextVNode("预览图")
const _hoisted_169 = { key: 1 }
const _hoisted_170 = { style: {"white-space":"nowrap"} }
const _hoisted_171 = /*#__PURE__*/_createTextVNode("返回")
const _hoisted_172 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_173 = /*#__PURE__*/_createTextVNode("关联Jira")
const _hoisted_174 = /*#__PURE__*/_createTextVNode("认领")
const _hoisted_175 = /*#__PURE__*/_createTextVNode("重启工单")
const _hoisted_176 = /*#__PURE__*/_createTextVNode("直接关闭")
const _hoisted_177 = {
  key: 0,
  class: "detial-show-tickets"
}
const _hoisted_178 = { class: "title" }
const _hoisted_179 = /*#__PURE__*/_createVNode("span", null, "请填写以下字段此工单将进入JIRA:", -1)
const _hoisted_180 = { class: "select" }
const _hoisted_181 = /*#__PURE__*/_createVNode("i", null, "*", -1)
const _hoisted_182 = /*#__PURE__*/_createVNode("span", { class: "label" }, " JIRA项目： ", -1)
const _hoisted_183 = { class: "select" }
const _hoisted_184 = /*#__PURE__*/_createVNode("i", null, "*", -1)
const _hoisted_185 = /*#__PURE__*/_createVNode("span", { class: "label" }, " 故障发生环境： ", -1)
const _hoisted_186 = {
  key: 0,
  class: "select"
}
const _hoisted_187 = /*#__PURE__*/_createVNode("i", null, "*", -1)
const _hoisted_188 = /*#__PURE__*/_createVNode("span", { class: "label" }, " 处理人： ", -1)
const _hoisted_189 = { class: "phase-select-dialog" }
const _hoisted_190 = /*#__PURE__*/_createVNode("div", { class: "title" }, "请选择工作流节点", -1)
const _hoisted_191 = { class: "content" }
const _hoisted_192 = /*#__PURE__*/_createVNode("div", { class: "label" }, "处理节点：", -1)
const _hoisted_193 = { class: "button-area" }
const _hoisted_194 = {
  class: "map-container",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_195 = {
  class: "canvas",
  ref: "mapCanvas",
  style: {"width":"100%","height":"100%"}
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_button = _resolveComponent("el-button")
  const _component_template_generator = _resolveComponent("template-generator")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_el_link = _resolveComponent("el-link")
  const _component_el_image = _resolveComponent("el-image")
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")
  const _component_el_timeline = _resolveComponent("el-timeline")
  const _component_el_tag = _resolveComponent("el-tag")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_upload = _resolveComponent("el-upload")
  const _component_OutputListCom = _resolveComponent("OutputListCom")
  const _component_TinymceEditor = _resolveComponent("TinymceEditor")
  const _component_el_form = _resolveComponent("el-form")
  const _component_TicketTemplateChange = _resolveComponent("TicketTemplateChange")
  const _component_TicketAddTag = _resolveComponent("TicketAddTag")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_el_container = _resolveComponent("el-container")
  const _component_PersonSelect = _resolveComponent("PersonSelect")
  const _component_checkStandDialog = _resolveComponent("checkStandDialog")
  const _component_WorkflowTaskAppiontDrawer = _resolveComponent("WorkflowTaskAppiontDrawer")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Breadcrumb, null, {
      default: _withId(() => [
        _createVNode("span", null, [
          _createVNode("a", {
            href: "javascript:void(0)",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.back()))
          }, "工单视图"),
          _hoisted_2
        ]),
        _hoisted_3
      ]),
      _: 1
    }),
    _createVNode("div", _hoisted_4, [
      _createVNode("div", null, [
        (_ctx.workflowId)
          ? (_openBlock(), _createBlock("div", _hoisted_5, [
              _hoisted_6,
              _createVNode(_component_el_input, {
                "model-value": _ctx.workflowName,
                disabled: ""
              }, null, 8, ["model-value"]),
              _createVNode("span", {
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => {_ctx.previewDialogVisible = true;_ctx.loadWorkflowMap()}, ["stop"])),
                class: "preview"
              }, [
                _hoisted_7,
                _hoisted_8
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.workflowId&&_ctx.taskAppointTable?.length>0)
          ? (_openBlock(), _createBlock("div", _hoisted_9, [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.taskAppointVisible=true))
              }, {
                default: _withId(() => [
                  _hoisted_10
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", null, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.templateUsedRecord, (t, index) => {
            return (_openBlock(), _createBlock("div", {
              class: "record-template",
              key: index
            }, [
              _createVNode("div", {
                class: "template-title",
                onClick: ($event: any) => (t.showItemTemplate = !t.showItemTemplate)
              }, [
                _createVNode("p", null, [
                  _createVNode("span", _hoisted_11, [
                    (t.showItemTemplate)
                      ? (_openBlock(), _createBlock("img", _hoisted_12))
                      : (_openBlock(), _createBlock("img", _hoisted_13))
                  ]),
                  _createVNode("span", null, _toDisplayString(t?.template?.fields?.name), 1)
                ]),
                _hoisted_14
              ], 8, ["onClick"]),
              (Object.keys(t?.template?.fields?.template).length > 0 && t.showItemTemplate)
                ? (_openBlock(), _createBlock(_component_template_generator, {
                    key: 0,
                    disabled: true,
                    "template-data": t?.template?.fields?.template,
                    value: t.fieldInfo,
                    "onUpdate:value": ($event: any) => (t.fieldInfo = $event)
                  }, null, 8, ["template-data", "value", "onUpdate:value"]))
                : _createCommentVNode("", true)
            ]))
          }), 128)),
          _createVNode("div", _hoisted_15, [
            _createVNode("div", _hoisted_16, [
              _createVNode("p", null, _toDisplayString(_ctx.currentTemplateInfo.template?.fields?.name || ''), 1),
              _hoisted_17
            ]),
            (Object.keys(_ctx.template).length > 0)
              ? (_openBlock(), _createBlock(_component_template_generator, {
                  key: 0,
                  disabled: !_ctx.isHandleable && !_ctx.isEditable,
                  ref: "templateGenerator",
                  "template-data": _ctx.template,
                  value: _ctx.templateValue,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (_ctx.templateValue = $event)),
                  onChange: _ctx.templateValueChange
                }, null, 8, ["disabled", "template-data", "value", "onChange"]))
              : _createCommentVNode("", true)
          ]),
          (!_ctx.workflowId)
            ? (_openBlock(), _createBlock("div", _hoisted_18, [
                _createVNode(_component_el_button, {
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showChangeTemplate = true)),
                  disabled: !_ctx.isHandleable && !_ctx.isEditable,
                  type: "primary",
                  plain: ""
                }, {
                  default: _withId(() => [
                    _hoisted_19,
                    _hoisted_20
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.workflowId)
          ? (_openBlock(), _createBlock("div", _hoisted_21, [
              _hoisted_22,
              _createVNode("div", _hoisted_23, [
                _hoisted_24,
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.planTime.start,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.planTime.start = $event)),
                  class: "date-select",
                  type: "date",
                  format: "YY-MM-DD",
                  placeholder: "选择项目开始时间",
                  onChange: _ctx.upMilestoneTime,
                  "default-time": new Date(0,0,0,0,0,0)
                }, null, 8, ["modelValue", "onChange", "default-time"])
              ]),
              _createVNode("div", _hoisted_25, [
                _hoisted_26,
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.planTime.end,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.planTime.end = $event)),
                  class: "date-select",
                  type: "date",
                  format: "YY-MM-DD",
                  placeholder: "选择项目结束时间",
                  "default-time": new Date(0,0,0,23,59,59),
                  onChange: _ctx.upMilestoneTime
                }, null, 8, ["modelValue", "default-time", "onChange"])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.workflowId)
          ? (_openBlock(), _createBlock("div", _hoisted_27, [
              _createVNode("div", _hoisted_28, [
                _hoisted_29,
                _createVNode(_component_el_tooltip, { content: "点击修改项目经理" }, {
                  default: _withId(() => [
                    (_ctx.projectBasieInfo?.projectManager)
                      ? (_openBlock(), _createBlock("span", {
                          key: 0,
                          style: {"cursor":"pointer"},
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.changeManager('projectManager')))
                        }, _toDisplayString(_ctx.projectBasieInfo?.projectManager), 1))
                      : (_openBlock(), _createBlock("span", {
                          key: 1,
                          style: {"cursor":"pointer","color":"#4B79F3"},
                          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.changeManager('projectManager')))
                        }, "点击修改"))
                  ]),
                  _: 1
                })
              ]),
              _createVNode("div", _hoisted_30, [
                _hoisted_31,
                _createVNode(_component_el_tooltip, { content: "点击修改交付经理" }, {
                  default: _withId(() => [
                    (_ctx.projectBasieInfo?.deliveryManager)
                      ? (_openBlock(), _createBlock("span", {
                          key: 0,
                          style: {"cursor":"pointer"},
                          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.changeManager('deliveryManager')))
                        }, _toDisplayString(_ctx.projectBasieInfo?.deliveryManager), 1))
                      : (_openBlock(), _createBlock("span", {
                          key: 1,
                          style: {"cursor":"pointer","color":"#4B79F3"},
                          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.changeManager('deliveryManager')))
                        }, "点击修改"))
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.milestoneList?.length)
          ? (_openBlock(), _createBlock("div", _hoisted_32, [
              _hoisted_33,
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.milestoneList, (item) => {
                return (_openBlock(), _createBlock("div", {
                  key: item,
                  class: "row"
                }, [
                  _createVNode("span", _hoisted_34, _toDisplayString(item.name), 1),
                  _createVNode(_component_el_date_picker, {
                    modelValue: item.time,
                    "onUpdate:modelValue": ($event: any) => (item.time = $event),
                    class: "date-select",
                    type: "date",
                    format: "YY-MM-DD",
                    placeholder: "选择关键节点时间",
                    onChange: _ctx.upMilestoneTime,
                    "default-time": new Date(0,0,0,23,59,59)
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange", "default-time"])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_35, [
          (_ctx.isHandleable)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.showTicketAddTag = true)),
                type: "primary",
                plain: ""
              }, {
                default: _withId(() => [
                  _hoisted_36,
                  _hoisted_37
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.showTicketAddTag = true)),
                type: "primary",
                disabled: ""
              }, {
                default: _withId(() => [
                  _hoisted_38,
                  _hoisted_39
                ]),
                _: 1
              })),
          _createVNode("div", null, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.ticket.fields?.extraTags || [], (l) => {
              return (_openBlock(), _createBlock("span", {
                key: l.id,
                class: "label"
              }, [
                _createVNode("span", null, _toDisplayString(l.name), 1),
                (_ctx.isHandleable)
                  ? (_openBlock(), _createBlock("i", {
                      key: 0,
                      class: "el-icon-close",
                      onClick: ($event: any) => (_ctx.deleteExtraTags(l.id))
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ])
      ]),
      _createVNode("div", null, [
        _createVNode("div", _hoisted_40, [
          _createVNode("span", null, [
            _createVNode("span", null, _toDisplayString(_ctx.ticket?.pk) + " - " + _toDisplayString(_ctx.ticket.fields?.title), 1),
            (_ctx.ticket.fields?.urgentLevel < 5)
              ? (_openBlock(), _createBlock("span", _hoisted_41, "紧急"))
              : _createCommentVNode("", true)
          ]),
          (_ctx.workflowId && _ctx.ticketAdmin)
            ? (_openBlock(), _createBlock("div", _hoisted_42, [
                _createVNode(_component_el_button, {
                  type: "primary",
                  plain: "",
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.$router.push({name: '工单时间修改',params: { id: _ctx.ticket?.pk }}))),
                  style: {"margin-left":"218px"}
                }, {
                  default: _withId(() => [
                    _hoisted_43,
                    _hoisted_44
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_el_button, {
            type: "primary",
            plain: "",
            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.$router.push({name: '问题详情',query: { problemId: _ctx.problemId, type: 'info' }}))),
            style: {"margin-left":"8px"}
          }, {
            default: _withId(() => [
              _hoisted_45,
              _hoisted_46
            ]),
            _: 1
          })
        ]),
        _createVNode("div", null, [
          _createVNode("div", _hoisted_47, [
            _hoisted_48,
            _createVNode("span", _hoisted_49, [
              _createVNode("span", {
                class: "max-img",
                innerHTML: _ctx.ticket.fields?.problem?.fields?.problemDescribe
              }, null, 8, ["innerHTML"])
            ])
          ]),
          (_ctx.ticketDesc)
            ? (_openBlock(), _createBlock("div", _hoisted_50, [
                _hoisted_51,
                _createVNode("span", _hoisted_52, [
                  _createVNode("span", {
                    class: "max-img",
                    innerHTML: _ctx.displayNewline(_ctx.ticketDesc?.record.comment)
                  }, null, 8, ["innerHTML"]),
                  (_ctx.notImageList(_ctx.ticketDesc?.record.attachments).length > 0)
                    ? (_openBlock(), _createBlock("div", _hoisted_53, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.notImageList(_ctx.ticketDesc?.record.attachments) || [], (am, i) => {
                          return (_openBlock(), _createBlock(_Fragment, {
                            key: am.key
                          }, [
                            (i===0 || _ctx.ticketDesc?.attachmentsOpened)
                              ? (_openBlock(), _createBlock("div", _hoisted_54, [
                                  _createVNode("div", null, [
                                    _createVNode("span", _hoisted_55, _toDisplayString(am.name), 1),
                                    (am.type==='url')
                                      ? (_openBlock(), _createBlock(_component_el_link, {
                                          key: 0,
                                          class: "file-download",
                                          href: am.url,
                                          target: "_blank"
                                        }, {
                                          default: _withId(() => [
                                            _hoisted_56
                                          ]),
                                          _: 2
                                        }, 1032, ["href"]))
                                      : (_openBlock(), _createBlock(_component_el_link, {
                                          key: 1,
                                          class: "file-download",
                                          href: am.url,
                                          target: "_blank"
                                        }, {
                                          default: _withId(() => [
                                            _hoisted_57
                                          ]),
                                          _: 2
                                        }, 1032, ["href"]))
                                  ]),
                                  (_ctx.notImageList(_ctx.ticketDesc?.record.attachments).length > 1 && i === 0)
                                    ? (_openBlock(), _createBlock("div", {
                                        key: 0,
                                        class: "right-btn",
                                        onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.ticketDesc.attachmentsOpened = !_ctx.ticketDesc.attachmentsOpened))
                                      }, [
                                        (_ctx.ticketDesc.attachmentsOpened)
                                          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                              _hoisted_58,
                                              _hoisted_59
                                            ], 64))
                                          : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                                              _hoisted_60,
                                              _hoisted_61
                                            ], 64))
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ], 64))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.imageList(_ctx.ticketDesc?.record.attachments).length > 0)
                    ? (_openBlock(), _createBlock("div", _hoisted_62, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.imageList(_ctx.ticketDesc?.record.attachments), (file) => {
                          return (_openBlock(), _createBlock(_Fragment, null, [
                            (_ctx.checkImage(file.name))
                              ? (_openBlock(), _createBlock("div", {
                                  key: file.key,
                                  class: "img-div"
                                }, [
                                  _createVNode(_component_el_image, {
                                    src: file.url,
                                    "preview-src-list": [file.url],
                                    style: {"width":"100px","height":"80px"}
                                  }, null, 8, ["src", "preview-src-list"])
                                ]))
                              : _createCommentVNode("", true)
                          ], 64))
                        }), 256))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.ticketDesc.record.extraTags?.length > 0)
                    ? (_openBlock(), _createBlock("div", _hoisted_63, [
                        _createVNode("span", null, "L" + _toDisplayString(_ctx.ticketDesc.phaseId) + "-" + _toDisplayString(_ctx.ticketDesc.operatorName) + " | 添加了标签：", 1),
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.ticketDesc.record.extraTags, (t, i) => {
                          return (_openBlock(), _createBlock("span", {
                            key: t.id
                          }, [
                            _createVNode("span", null, _toDisplayString(t.name), 1),
                            (i !== _ctx.ticketDesc.record.extraTags.length - 1)
                              ? (_openBlock(), _createBlock("span", _hoisted_64, "、"))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_65, [
            _hoisted_66,
            _createVNode("span", _hoisted_67, [
              _createVNode("span", _hoisted_68, _toDisplayString(_ctx.ticket.fields?.urgentLevel), 1)
            ])
          ]),
          _createVNode(_component_el_timeline, null, {
            default: _withId(() => [
              _createVNode(_component_el_timeline_item, null, {
                default: _withId(() => [
                  _createVNode("div", _hoisted_69, [
                    _hoisted_70,
                    _createVNode("span", _hoisted_71, [
                      _createTextVNode(_toDisplayString(_ctx.ticketOr(_ctx.ticket.fields?.problem?.fields)), 1),
                      _hoisted_72,
                      _createVNode("span", _hoisted_73, _toDisplayString(_ctx.ticket.fields?.problem?.fields?.createTime && _ctx.formatDate(_ctx.ticket.fields.problem.fields.createTime)), 1)
                    ]),
                    _hoisted_74
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_timeline_item, null, {
                default: _withId(() => [
                  _createVNode("div", _hoisted_75, [
                    _hoisted_76,
                    _createVNode("span", _hoisted_77, [
                      _createTextVNode(_toDisplayString(_ctx.ticket.fields?.creatorName || _ctx.ticket.fields?.creator), 1),
                      _hoisted_78,
                      _createVNode("span", _hoisted_79, _toDisplayString(_ctx.ticket.fields?.createdAt && _ctx.formatDate(_ctx.ticket.fields.createdAt)), 1)
                    ]),
                    _hoisted_80,
                    _createVNode("span", _hoisted_81, _toDisplayString(_ctx.formatTime(_ctx.ticket.fields?.createdAt - _ctx.ticket.fields?.problem?.fields?.createTime)), 1)
                  ])
                ]),
                _: 1
              }),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.transactions.slice(1), (transaction, index) => {
                return (_openBlock(), _createBlock(_component_el_timeline_item, {
                  class: {
              'middle': transaction.transactionType === 'claim' || transaction.transactionType === 'assign' || transaction.transactionType === 'redraw',
              'mb-24': transaction.transactionType === 'claim'|| transaction.transactionType === 'assign' ,
              'mt-24': transaction.transactionType === 'redraw',
            },
                  key: transaction.id
                }, {
                  default: _withId(() => [
                    (transaction.transactionType === 'claim'|| transaction.transactionType === 'assign')
                      ? (_openBlock(), _createBlock("div", _hoisted_82))
                      : _createCommentVNode("", true),
                    _createVNode("div", _hoisted_83, [
                      (transaction.transactionType === 'finish')
                        ? (_openBlock(), _createBlock("span", _hoisted_84, "已解决"))
                        : (transaction.transactionType === 'change_template')
                          ? (_openBlock(), _createBlock("span", _hoisted_85, "变更"))
                          : (transaction.transactionType === 'suspend')
                            ? (_openBlock(), _createBlock("span", _hoisted_86, "挂起"))
                            : (transaction.transactionType === 'restart')
                              ? (_openBlock(), _createBlock("span", _hoisted_87, "重启"))
                              : (_openBlock(), _createBlock("span", _hoisted_88)),
                      (transaction.transactionType === 'finish' || transaction.transactionType === 'handle' || transaction.transactionType === 'change_template' || transaction.transactionType === 'suspend')
                        ? (_openBlock(), _createBlock("span", _hoisted_89, [
                            _createVNode("span", _hoisted_90, [
                              _createTextVNode(_toDisplayString(transaction.record?.notesComponents?.phaseName) + " ", 1),
                              (transaction.record?.notesComponents?.phaseName)
                                ? (_openBlock(), _createBlock("span", _hoisted_91, "-"))
                                : _createCommentVNode("", true),
                              _createTextVNode(" " + _toDisplayString(transaction.record?.notesComponents?.agentName) + " ", 1),
                              _hoisted_92,
                              _createVNode("div", _hoisted_93, [
                                _createVNode("span", _hoisted_94, _toDisplayString(_ctx.formatDate(transaction.createdAt)), 1)
                              ]),
                              _hoisted_95
                            ])
                          ]))
                        : (_openBlock(), _createBlock("div", {
                            key: 6,
                            class: ["operation-record", {'record-grey': transaction.transactionType === 'redraw', 'is-jira-go': transaction.transactionType === 'create_to_jira'}]
                          }, [
                            _createVNode("span", _hoisted_96, _toDisplayString(_ctx.formatDate(transaction.createdAt)), 1),
                            (transaction.record?.notes)
                              ? (_openBlock(), _createBlock("span", _hoisted_97, _toDisplayString(transaction.record?.notes), 1))
                              : (_openBlock(), _createBlock("span", _hoisted_98, [
                                  _createTextVNode(_toDisplayString(transaction.record?.notesComponents?.phaseName), 1),
                                  (transaction.record?.notesComponents?.phaseName)
                                    ? (_openBlock(), _createBlock("span", _hoisted_99, "-"))
                                    : _createCommentVNode("", true),
                                  _createTextVNode(_toDisplayString(transaction.record?.notesComponents?.agentName), 1)
                                ])),
                            _createVNode("span", null, _toDisplayString(transaction.record?.comment), 1)
                          ], 2)),
                      (transaction.transactionType === 'finish' || transaction.transactionType === 'handle' || transaction.transactionType === 'change_template' || transaction.transactionType === 'suspend')
                        ? (_openBlock(), _createBlock("span", _hoisted_100, [
                            _createVNode("span", {
                              class: ["max-img", {'change-text': transaction.transactionType === 'change_template', 'delayed-text': transaction.transactionType === 'delayed'}],
                              innerHTML: transaction.record.comment
                            }, null, 10, ["innerHTML"]),
                            (_ctx.notImageList(transaction.record.attachments).length > 0)
                              ? (_openBlock(), _createBlock("div", _hoisted_101, [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.notImageList(transaction.record.attachments) || [], (am, i) => {
                                    return (_openBlock(), _createBlock(_Fragment, {
                                      key: am.key
                                    }, [
                                      (i===0 || transaction.attachmentsOpened)
                                        ? (_openBlock(), _createBlock("div", _hoisted_102, [
                                            _createVNode("div", null, [
                                              _createVNode("span", _hoisted_103, _toDisplayString(am.name), 1),
                                              (am.type==='url')
                                                ? (_openBlock(), _createBlock(_component_el_link, {
                                                    key: 0,
                                                    class: "file-download",
                                                    href: am.url,
                                                    target: "_blank"
                                                  }, {
                                                    default: _withId(() => [
                                                      _hoisted_104
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["href"]))
                                                : (_openBlock(), _createBlock(_component_el_link, {
                                                    key: 1,
                                                    class: "file-download",
                                                    href: am.url,
                                                    target: "_blank"
                                                  }, {
                                                    default: _withId(() => [
                                                      _hoisted_105
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["href"]))
                                            ]),
                                            (_ctx.notImageList(transaction.record.attachments).length > 1 && i === 0)
                                              ? (_openBlock(), _createBlock("div", {
                                                  key: 0,
                                                  class: "right-btn",
                                                  onClick: ($event: any) => (transaction.attachmentsOpened = !transaction.attachmentsOpened)
                                                }, [
                                                  (transaction.attachmentsOpened)
                                                    ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                                        _hoisted_106,
                                                        _hoisted_107
                                                      ], 64))
                                                    : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                                                        _hoisted_108,
                                                        _hoisted_109
                                                      ], 64))
                                                ], 8, ["onClick"]))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ], 64))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.imageList(transaction.record.attachments).length > 0)
                              ? (_openBlock(), _createBlock("div", _hoisted_110, [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.imageList(transaction.record.attachments), (file) => {
                                    return (_openBlock(), _createBlock(_Fragment, null, [
                                      (_ctx.checkImage(file.name))
                                        ? (_openBlock(), _createBlock("div", {
                                            key: file.key,
                                            class: "img-div"
                                          }, [
                                            _createVNode(_component_el_image, {
                                              src: file.url,
                                              "preview-src-list": [file.url],
                                              style: {"width":"100px","height":"80px"}
                                            }, null, 8, ["src", "preview-src-list"])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ], 64))
                                  }), 256))
                                ]))
                              : _createCommentVNode("", true),
                            (transaction.record.extraTags?.length > 0)
                              ? (_openBlock(), _createBlock("div", _hoisted_111, [
                                  _createVNode("span", null, _toDisplayString(transaction.record?.notesComponents?.phaseName) + " - " + _toDisplayString(transaction.record?.notesComponents?.agentName) + " | 添加了标签：", 1),
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(transaction.record.extraTags, (t, i) => {
                                    return (_openBlock(), _createBlock("span", {
                                      key: t.id
                                    }, [
                                      _createVNode("span", null, _toDisplayString(t.name), 1),
                                      (i !== transaction.record.extraTags.length - 1)
                                        ? (_openBlock(), _createBlock("span", _hoisted_112, "、"))
                                        : _createCommentVNode("", true)
                                    ]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.workflowId && (transaction.record?.formInfo?.outFields?.length>0 ))
                              ? (_openBlock(), _createBlock("span", {
                                  key: 3,
                                  onClick: ($event: any) => (_ctx.getFlowDetail(transaction, 'add')),
                                  class: "view-details"
                                }, [
                                  _hoisted_113,
                                  _hoisted_114
                                ], 8, ["onClick"]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (transaction.transactionType === 'finish' || transaction.transactionType === 'handle')
                        ? (_openBlock(), _createBlock("span", _hoisted_115, _toDisplayString(_ctx.transactions[index+1].consumeTime ? _ctx.formatTime(_ctx.transactions[index+1].consumeTime) :
                ((_ctx.transactions[index+1]?.createdAt - _ctx.transactions[index]?.createdAt) ? _ctx.formatTime(_ctx.transactions[index+1].createdAt - _ctx.transactions[index].createdAt) : '')), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createTextVNode(" " + _toDisplayString(transaction.transactionTyp) + " ", 1),
                    (index+1 === _ctx.transactions.slice(1)?.length&&_ctx.ticket.fields?.curStatus !== 'pending'&&_ctx.ticket.fields?.curStatus !== 'closed')
                      ? (_openBlock(), _createBlock("span", {
                          key: 1,
                          class: "transfer-button line-transfer",
                          onClick: ($event: any) => (_ctx.changePersonSelect(transaction?.phaseId))
                        }, "指派", 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["class"]))
              }), 128)),
              (_ctx.ticket.fields?.curStatus === 'pending')
                ? (_openBlock(), _createBlock(_component_el_timeline_item, {
                    key: 0,
                    class: {'mt24':_ctx.transactions[_ctx.transactions.length - 1].transactionType === 'claim'}
                  }, {
                    default: _withId(() => [
                      _createVNode("div", _hoisted_116, [
                        _hoisted_117,
                        _createVNode("span", _hoisted_118, _toDisplayString(_ctx.ticket.fields?.responsibleAgentName), 1),
                        (_ctx.workflowId)
                          ? (_openBlock(), _createBlock("div", _hoisted_119, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.ticket.fields?.curPhases, (p) => {
                                return (_openBlock(), _createBlock("span", {
                                  key: p.phaseId,
                                  style: {"display":"flex","align-items":"center","margin":"5px 0"}
                                }, [
                                  (p.curStatus == 'pending')
                                    ? (_openBlock(), _createBlock("p", _hoisted_120, [
                                        _createTextVNode(_toDisplayString(p.phaseName) + " - 处理中 - " + _toDisplayString(p.responsibleAgentName) + " ", 1),
                                        _createVNode("span", {
                                          class: "transfer-button",
                                          onClick: ($event: any) => (_ctx.changePersonSelect(p.phaseId, 'pending'))
                                        }, "指派", 8, ["onClick"]),
                                        _hoisted_121
                                      ]))
                                    : _createCommentVNode("", true),
                                  (p.curStatus == 'suspended')
                                    ? (_openBlock(), _createBlock("p", _hoisted_122, [
                                        _createTextVNode(_toDisplayString(p.phaseName) + " - 挂起 - " + _toDisplayString(p.responsibleAgentName) + " ", 1),
                                        _createVNode("span", {
                                          class: "transfer-button",
                                          onClick: ($event: any) => (_ctx.changePersonSelect(p.phaseId, 'pending'))
                                        }, "指派", 8, ["onClick"]),
                                        _hoisted_123
                                      ]))
                                    : _createCommentVNode("", true),
                                  (p.curStatus == 'unassigned')
                                    ? (_openBlock(), _createBlock("span", _hoisted_124, [
                                        _createTextVNode(_toDisplayString(p.phaseName) + " - 待认领 - 可认领人：" + _toDisplayString(p.claimable.join('、') || '无') + " ", 1),
                                        (p.curStatus === 'unassigned')
                                          ? (_openBlock(), _createBlock("span", {
                                              key: 0,
                                              class: "transfer-button",
                                              onClick: ($event: any) => (_ctx.changePersonSelect(p.phaseId))
                                            }, "指派", 8, ["onClick"]))
                                          : _createCommentVNode("", true),
                                        _hoisted_125
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            ]))
                          : (_openBlock(), _createBlock("span", _hoisted_126, [
                              _createTextVNode(_toDisplayString(_ctx.ticket.fields?.responsibleAgentName), 1),
                              _hoisted_127
                            ]))
                      ])
                    ]),
                    _: 1
                  }, 8, ["class"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        (_ctx.isHandleable)
          ? (_openBlock(), _createBlock("div", {
              key: 0,
              style: {"position":"relative"},
              class: {'bottom-fixed-box':_ctx.replyShowType === 2}
            }, [
              _createVNode("div", _hoisted_128, [
                _createVNode("div", _hoisted_129, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.processablePhases, (t, idx) => {
                    return (_openBlock(), _createBlock("div", {
                      class: {'tab-box':true, 'active-tab': _ctx.selectedPhase===t.phaseId,'tab-cur':t.curStatus },
                      key: t,
                      onClick: ($event: any) => (_ctx.getFlowDetail(t, 'tab'))
                    }, [
                      _createTextVNode(_toDisplayString(t?.phaseName) + " ", 1),
                      (_ctx.selectedPhase===t.phaseId && !t?.curStatus)
                        ? (_openBlock(), _createBlock("span", {
                            key: 0,
                            onClick: _withModifiers(($event: any) => (_ctx.closeTab(t, idx, _ctx.selectedPhase===t.phaseId && !t?.curStatus)), ["stop"]),
                            class: {'tab-close':true}
                          }, [
                            _hoisted_130
                          ], 8, ["onClick"]))
                        : _createCommentVNode("", true)
                    ], 10, ["onClick"]))
                  }), 128))
                ])
              ]),
              (_ctx.replyShowType === 2 )
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    (_ctx.showCurBox)
                      ? (_openBlock(), _createBlock("div", {
                          key: 0,
                          class: "tab-control",
                          onClick: _cache[17] || (_cache[17] = ()=> _ctx.showCurBox=false)
                        }, "收起"))
                      : (_openBlock(), _createBlock("div", {
                          key: 1,
                          class: "tab-control",
                          onClick: _cache[18] || (_cache[18] = ()=> _ctx.showCurBox=true)
                        }, "展开节点回复信息"))
                  ], 64))
                : _createCommentVNode("", true),
              _withDirectives(_createVNode(_component_el_form, {
                model: _ctx.ruleForm,
                rules: _ctx.rules,
                ref: "ruleFormRef"
              }, {
                default: _withId(() => [
                  _createVNode("div", null, [
                    (_ctx.workflowId)
                      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                          (_ctx.replyDisable)
                            ? (_openBlock(), _createBlock("div", _hoisted_131, [
                                _createVNode(_component_el_tag, {
                                  class: "ml-2",
                                  type: "info"
                                }, {
                                  default: _withId(() => [
                                    _hoisted_132
                                  ]),
                                  _: 1
                                })
                              ]))
                            : _createCommentVNode("", true),
                          _createVNode(_component_el_form_item, {
                            label: "当前节点：",
                            prop: "nextProcess"
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.selectedPhase,
                                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.selectedPhase = $event)),
                                "default-first-option": "",
                                onChange: _ctx.handlePhaseChange
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.processablePhases, (l) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: l.phaseId,
                                      value: l.phaseId,
                                      label: l.phaseName
                                    }, null, 8, ["value", "label"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "onChange"])
                            ]),
                            _: 1
                          }),
                          (!_ctx.replyDisable)
                            ? (_openBlock(true), _createBlock(_Fragment, { key: 1 }, _renderList(_ctx.taskVariables, (v, k) => {
                                return (_openBlock(), _createBlock(_component_el_form_item, {
                                  label: "通过：",
                                  key: k,
                                  prop: k,
                                  rules: { required: true, message: '请选择',
        trigger: 'blur' }
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_select, {
                                      modelValue: _ctx.taskVariables[k],
                                      "onUpdate:modelValue": ($event: any) => (_ctx.taskVariables[k] = $event),
                                      "default-first-option": "",
                                      placeholder: "请选择是否通过",
                                      onChange: (item)=>_ctx.changeIsPass(k,item)
                                    }, {
                                      default: _withId(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.taskVariablesOptions, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            value: item.value,
                                            label: item?.name,
                                            key: item.value
                                          }, null, 8, ["value", "label"]))
                                        }), 128))
                                      ]),
                                      _: 2
                                    }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"])
                                  ]),
                                  _: 2
                                }, 1032, ["prop"]))
                              }), 128))
                            : _createCommentVNode("", true),
                          _createVNode("div", {
                            class: "option-suffix",
                            onClick: _cache[20] || (_cache[20] = _withModifiers(($event: any) => {_ctx.previewDialogVisible = true; _ctx.loadWorkflowMap()}, ["stop"]))
                          }, [
                            _hoisted_133,
                            _hoisted_134
                          ])
                        ], 64))
                      : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                          _createVNode(_component_el_form_item, {
                            label: "下一阶段：",
                            prop: "nextProcess"
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.ruleForm.nextProcess,
                                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.ruleForm.nextProcess = $event)),
                                onChange: _ctx.changeNextProcess,
                                placeholder: "请选择"
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.processLabels, (l) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: l.id,
                                      value: l.id,
                                      label: l.name
                                    }, null, 8, ["value", "label"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "onChange"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, {
                            label: "处理人：",
                            prop: "nextHandler"
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                clearable: "",
                                modelValue: _ctx.ruleForm.nextHandler,
                                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.ruleForm.nextHandler = $event)),
                                placeholder: "请选择",
                                filterable: ""
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.handlers, (p) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: p.id,
                                      value: p.ldap,
                                      label: p.name
                                    }, {
                                      default: _withId(() => [
                                        _createTextVNode(_toDisplayString(p.name) + "（" + _toDisplayString(p.ldap) + "）", 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["value", "label"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ], 64)),
                    (!_ctx.replyDisable)
                      ? (_openBlock(), _createBlock(_component_el_upload, {
                          key: 2,
                          multiple: "",
                          action: " ",
                          "show-file-list": false,
                          ref: "fileUploader",
                          class: "upload-file",
                          "http-request": _ctx.uploadFile,
                          "on-preview": _ctx.handlePreview,
                          "on-remove": _ctx.handleRemove
                        }, {
                          default: _withId(() => [
                            _withDirectives(_createVNode(_component_el_button, {
                              class: "upload-btn",
                              size: "small"
                            }, {
                              default: _withId(() => [
                                _hoisted_135,
                                _hoisted_136
                              ]),
                              _: 1
                            }, 512), [
                              [
                                _directive_loading,
                                _ctx.uploading,
                                void 0,
                                {
                                  fullscreen: true,
                                  lock: true
                                }
                              ]
                            ]),
                            _withDirectives(_createVNode(_component_el_button, {
                              class: "upload-btn",
                              size: "small",
                              onClick: _cache[23] || (_cache[23] = _withModifiers(($event: any) => (_ctx.addFeishuFileVisible=true), ["stop"]))
                            }, {
                              default: _withId(() => [
                                _hoisted_137,
                                _hoisted_138
                              ]),
                              _: 1
                            }, 512), [
                              [
                                _directive_loading,
                                _ctx.uploading,
                                void 0,
                                {
                                  fullscreen: true,
                                  lock: true
                                }
                              ]
                            ])
                          ]),
                          _: 1
                        }, 8, ["http-request", "on-preview", "on-remove"]))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.nodeRemark)
                    ? (_openBlock(), _createBlock("div", _hoisted_139, [
                        _hoisted_140,
                        _createVNode("div", {
                          innerHTML: _ctx.nodeRemark,
                          class: "node-remark-content"
                        }, null, 8, ["innerHTML"])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_form_item, {
                    label: "",
                    class: "tinymce-editor-wrap",
                    prop: "newReply"
                  }, {
                    default: _withId(() => [
                      _createVNode("div", _hoisted_141, [
                        (_ctx.inputData?.length>0)
                          ? (_openBlock(), _createBlock("div", _hoisted_142, [
                              _hoisted_143,
                              _createVNode("div", _hoisted_144, [
                                _createVNode(_component_OutputListCom, {
                                  dataList: _ctx.inputData,
                                  disable: true
                                }, null, 8, ["dataList"])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.outputData?.length>0)
                          ? (_openBlock(), _createBlock("div", _hoisted_145, [
                              _hoisted_146,
                              _createVNode("div", _hoisted_147, [
                                _createVNode(_component_OutputListCom, {
                                  dataList: _ctx.outputData,
                                  ref: "outputCom",
                                  "onUpdate:list": _cache[24] || (_cache[24] = (val) => _ctx.outputParams = val),
                                  disable: _ctx.replyDisable
                                }, null, 8, ["dataList", "disable"])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode("div", null, [
                          _hoisted_148,
                          _createVNode("div", _hoisted_149, [
                            _createVNode(_component_TinymceEditor, {
                              height: 240,
                              placeholder: "工单描述模板：比如什么时间，什么问题",
                              ref: "refTinymceEditor",
                              value: _ctx.ruleForm.newReply,
                              "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => (_ctx.ruleForm.newReply = $event)),
                              disabled: _ctx.replyDisable
                            }, null, 8, ["value", "disabled"])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  (_ctx.fileList.length > 0)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 1,
                        label: "附件:",
                        class: "tinymce-editor-wrap"
                      }, {
                        default: _withId(() => [
                          _createVNode("div", _hoisted_150, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.fileList, (file, i) => {
                              return (_openBlock(), _createBlock(_Fragment, null, [
                                (_ctx.checkImage(file.name))
                                  ? (_openBlock(), _createBlock("div", {
                                      key: file.key,
                                      class: "img-div"
                                    }, [
                                      _createVNode(_component_el_image, {
                                        src: file.url,
                                        "preview-src-list": [file.url],
                                        style: {"width":"100px","height":"80px"}
                                      }, null, 8, ["src", "preview-src-list"]),
                                      _createVNode("span", {
                                        class: "icon-del",
                                        onClick: ($event: any) => (_ctx.fileList.splice(i, 1))
                                      }, null, 8, ["onClick"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 64))
                            }), 256))
                          ]),
                          _createVNode("div", _hoisted_151, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.fileList, (file, i) => {
                              return (_openBlock(), _createBlock(_Fragment, null, [
                                (!_ctx.checkImage(file.name))
                                  ? (_openBlock(), _createBlock("div", {
                                      key: file.key,
                                      class: "img-div"
                                    }, [
                                      (file.type==='url')
                                        ? (_openBlock(), _createBlock("div", _hoisted_152, [
                                            _createTextVNode(" 链接:" + _toDisplayString(file.url) + " ", 1),
                                            _createVNode("span", {
                                              class: "icon-del",
                                              onClick: ($event: any) => (_ctx.fileList.splice(i, 1))
                                            }, null, 8, ["onClick"])
                                          ]))
                                        : (_openBlock(), _createBlock("div", _hoisted_153, [
                                            _createTextVNode(_toDisplayString(file.name) + " ", 1),
                                            _createVNode("span", {
                                              class: "icon-del",
                                              onClick: ($event: any) => (_ctx.fileList.splice(i, 1))
                                            }, null, 8, ["onClick"])
                                          ]))
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 64))
                            }), 256))
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (!_ctx.replyDisable)
                    ? (_openBlock(), _createBlock("div", _hoisted_154, [
                        _createVNode(_component_el_button, {
                          class: "cancel-btn",
                          onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.$router.back()))
                        }, {
                          default: _withId(() => [
                            _hoisted_155
                          ]),
                          _: 1
                        }),
                        (_ctx.workflowId)
                          ? (_openBlock(), _createBlock(_component_el_button, {
                              key: 0,
                              class: "close-btn",
                              onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.ticketContinue('skip')))
                            }, {
                              default: _withId(() => [
                                _hoisted_156
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.transactions[_ctx.transactions.length - 1].transactionType !== 'suspend')
                          ? (_openBlock(), _createBlock(_component_el_button, {
                              key: 1,
                              class: "suspend-btn",
                              type: "warning",
                              onClick: _ctx.delayedProcess
                            }, {
                              default: _withId(() => [
                                _hoisted_157
                              ]),
                              _: 1
                            }, 8, ["onClick"]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_el_button, {
                          class: "continue-btn",
                          onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.ticketContinue()))
                        }, {
                          default: _withId(() => [
                            _hoisted_158
                          ]),
                          _: 1
                        }),
                        (!_ctx.workflowId)
                          ? (_openBlock(), _createBlock(_component_el_button, {
                              key: 2,
                              class: (_ctx.ruleForm.nextProcess || _ctx.ruleForm.nextHandler) ? '' : 'resolved-btn',
                              onClick: _ctx.ticketClose
                            }, {
                              default: _withId(() => [
                                _hoisted_159
                              ]),
                              _: 1
                            }, 8, ["class", "onClick"]))
                          : _createCommentVNode("", true),
                        (!_ctx.workflowId)
                          ? (_openBlock(), _createBlock(_component_el_button, {
                              key: 3,
                              class: "csservice-btn",
                              onClick: _ctx.csService
                            }, {
                              default: _withId(() => [
                                _hoisted_160
                              ]),
                              _: 1
                            }, 8, ["onClick"]))
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_161))
                ]),
                _: 1
              }, 8, ["model", "rules"]), [
                [_vShow, _ctx.showCurBox]
              ])
            ], 2))
          : (_openBlock(), _createBlock("div", _hoisted_162, [
              (_ctx.workflowId)
                ? (_openBlock(), _createBlock("div", _hoisted_163, [
                    _createVNode("span", null, [
                      _hoisted_164,
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.workFlowCurrentStatus, (item) => {
                        return (_openBlock(), _createBlock(_component_el_tooltip, {
                          key: item.node,
                          content: item.name,
                          placement: "top"
                        }, {
                          default: _withId(() => [
                            _createVNode("span", _hoisted_165, _toDisplayString(item?.node), 1)
                          ]),
                          _: 2
                        }, 1032, ["content"]))
                      }), 128))
                    ]),
                    _hoisted_166,
                    _createVNode("span", {
                      onClick: _cache[29] || (_cache[29] = _withModifiers(($event: any) => (_ctx.previewDialogVisible = true), ["stop"])),
                      class: "preview"
                    }, [
                      _hoisted_167,
                      _hoisted_168
                    ])
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_169)),
              _createVNode("div", _hoisted_170, [
                _createVNode(_component_el_button, {
                  onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.$router.back()))
                }, {
                  default: _withId(() => [
                    _hoisted_171
                  ]),
                  _: 1
                }),
                (_ctx.relationJiraBtn)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      class: ["jira-class", {'is-none': _ctx.ticket.createToJira}],
                      disabled: _ctx.jiraButtonDiasable2,
                      onClick: _ctx.ticketRelationJira
                    }, {
                      default: _withId(() => [
                        _hoisted_172
                      ]),
                      _: 1
                    }, 8, ["class", "disabled", "onClick"]))
                  : (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      class: ["jira-class", {'is-none': _ctx.ticket.createToJira}],
                      onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.ticketContJira('relation')))
                    }, {
                      default: _withId(() => [
                        _hoisted_173
                      ]),
                      _: 1
                    }, 8, ["class"])),
                (_ctx.isClaimable)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 2,
                      type: "primary",
                      onClick: _ctx.assignMe
                    }, {
                      default: _withId(() => [
                        _hoisted_174
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.isFinish)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 3,
                      class: "restart-class",
                      onClick: _ctx.restartTicket
                    }, {
                      default: _withId(() => [
                        _hoisted_175
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.isDirectClosable)
                  ? (_openBlock(), _createBlock(_component_el_tooltip, {
                      key: 4,
                      content: "工单创建者可以直接关闭工单",
                      placement: "top"
                    }, {
                      default: _withId(() => [
                        (_ctx.isDirectClosable)
                          ? (_openBlock(), _createBlock(_component_el_button, {
                              key: 0,
                              class: "close-class",
                              onClick: _ctx.ticketDirectClose
                            }, {
                              default: _withId(() => [
                                _hoisted_176
                              ]),
                              _: 1
                            }, 8, ["onClick"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ]))
      ])
    ]),
    (_ctx.detialShowTickets)
      ? (_openBlock(), _createBlock("div", _hoisted_177, [
          _createVNode("div", _hoisted_178, [
            _hoisted_179,
            _createVNode("i", {
              onClick: _cache[32] || (_cache[32] = ($event: any) => {_ctx.detialShowTickets = false; _ctx.relationJiraBtn = false}),
              class: "el-icon-close"
            })
          ]),
          _createVNode("div", _hoisted_180, [
            _hoisted_181,
            _hoisted_182,
            _createVNode(_component_el_select, {
              modelValue: _ctx.jiraProject,
              "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => (_ctx.jiraProject = $event)),
              placeholder: "请选择",
              filterable: ""
            }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.jiraProjectList, (item, i) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    label: item.name,
                    value: item.name,
                    key: i
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createVNode("div", _hoisted_183, [
            _hoisted_184,
            _hoisted_185,
            _createVNode(_component_el_select, {
              modelValue: _ctx.errorEnv,
              "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (_ctx.errorEnv = $event)),
              placeholder: "请选择",
              filterable: ""
            }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.errorEnvList, (item, i) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    label: item.name,
                    value: item.name,
                    key: i
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          (_ctx.contJiraType === 'relation')
            ? (_openBlock(), _createBlock("div", _hoisted_186, [
                _hoisted_187,
                _hoisted_188,
                _createVNode(_component_el_select, {
                  modelValue: _ctx.handlerJira,
                  "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (_ctx.handlerJira = $event)),
                  placeholder: "请选择",
                  filterable: ""
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.jiraHandlers, (p) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: p.id,
                        value: p.ldap,
                        label: p.name
                      }, null, 8, ["value", "label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.showChangeTemplate)
      ? (_openBlock(), _createBlock(_component_TicketTemplateChange, {
          key: 1,
          show: _ctx.showChangeTemplate,
          "onUpdate:show": _cache[36] || (_cache[36] = ($event: any) => (_ctx.showChangeTemplate = $event)),
          "ticket-id": Number(_ctx.$route.params.id),
          "relation-map": _ctx.currentTemplateInfo?.template?.fields?.relationMap,
          value: _ctx.currentTemplateInfo?.fieldInfo,
          "current-template-id": Number(_ctx.currentTemplateInfo.template?.pk),
          onUpdate: _ctx.loadTicketDetail
        }, null, 8, ["show", "ticket-id", "relation-map", "value", "current-template-id", "onUpdate"]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      "destroy-on-close": "",
      modelValue: _ctx.showTicketAddTag,
      "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => (_ctx.showTicketAddTag = $event)),
      "custom-class": "ticket-add-tag-dialog",
      "show-close": false,
      width: "681px"
    }, {
      default: _withId(() => [
        _createVNode(_component_TicketAddTag, {
          "checked-tags": _ctx.ticket.fields.extraTags,
          cancel: () => _ctx.showTicketAddTag = false,
          submit: _ctx.onSubmit
        }, null, 8, ["checked-tags", "cancel", "submit"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode("div", _hoisted_189, [
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.showPhaseSelectDialog,
        "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => (_ctx.showPhaseSelectDialog = $event)),
        width: "364px"
      }, {
        default: _withId(() => [
          _hoisted_190,
          _createVNode("div", _hoisted_191, [
            _hoisted_192,
            _createVNode(_component_el_select, {
              modelValue: _ctx.selectedPhase,
              "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => (_ctx.selectedPhase = $event))
            }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.claimablePhases, (phase) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: phase.phaseId,
                    value: phase.phaseId,
                    label: phase.phaseName
                  }, null, 8, ["value", "label"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createVNode("div", _hoisted_193, [
            _createVNode("div", {
              class: "cancel-button",
              onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.showPhaseSelectDialog = false))
            }, "取 消"),
            _createVNode("div", {
              class: "confirm-button",
              onClick: _cache[40] || (_cache[40] = 
//@ts-ignore
(...args) => (_ctx.assignWithPhase && _ctx.assignWithPhase(...args)))
            }, "确 定")
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createVNode(_component_el_dialog, {
      title: _ctx.workflowName,
      modelValue: _ctx.previewDialogVisible,
      "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => (_ctx.previewDialogVisible = $event)),
      width: "80%",
      style: {"position":"relative"}
    }, {
      default: _withId(() => [
        _createVNode(_component_el_container, { style: {"width":"100%","height":"60vh"} }, {
          default: _withId(() => [
            _createVNode("div", _hoisted_194, [
              _createVNode("div", _hoisted_195, null, 512)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["title", "modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.showManagePersonalVisible,
      "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => (_ctx.showManagePersonalVisible = $event)),
      "show-close": false,
      "destroy-on-close": "",
      width: 400,
      "custom-class": "person-select-dialog"
    }, {
      default: _withId(() => [
        _createVNode(_component_PersonSelect, {
          cancel: () => _ctx.showManagePersonalVisible=false,
          submit: _ctx.submitChangeManager
        }, null, 8, ["cancel", "submit"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.transferPersonVisible,
      "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => (_ctx.transferPersonVisible = $event)),
      "show-close": false,
      "destroy-on-close": "",
      width: 400,
      "custom-class": "person-select-dialog"
    }, {
      default: _withId(() => [
        _createVNode(_component_PersonSelect, {
          cancel: _ctx.cancelPersonSelect,
          submit: _ctx.submitPersonSelect
        }, null, 8, ["cancel", "submit"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_checkStandDialog, {
      show: _ctx.addFeishuFileVisible,
      "onUpdate:show": _cache[46] || (_cache[46] = ($event: any) => (_ctx.addFeishuFileVisible = $event)),
      title: "上传飞书文档",
      width: "400px",
      confirmFn: _ctx.addFeishuConfirmFn
    }, {
      default: _withId(() => [
        _createVNode(_component_el_input, {
          modelValue: _ctx.activeFeishuFile,
          "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => (_ctx.activeFeishuFile = $event)),
          placeholder: "请输入/粘贴飞书文档链接",
          clearable: ""
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["show", "confirmFn"]),
    _createVNode(_component_WorkflowTaskAppiontDrawer, {
      show: _ctx.taskAppointVisible,
      "onUpdate:show": _cache[47] || (_cache[47] = ($event: any) => (_ctx.taskAppointVisible = $event)),
      taskAppointTable: _ctx.taskAppointTable,
      onChangeList: _ctx.changeAppointList
    }, null, 8, ["show", "taskAppointTable", "onChangeList"])
  ]))
})